/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { MapContainer, TileLayer, Polygon } from 'react-leaflet';
import AppContext from 'context/Context';
import 'leaflet.tilelayer.colorfilter';
import 'leaflet/dist/leaflet.css';
import '@changey/react-leaflet-markercluster/dist/styles.min.css';
import { isEmpty } from 'lodash';
import Legend from 'components/common/map/Legend';
import { getColorScale } from 'helpers/leaflet-utils';
import GeotiffLayerSideBySide from '../default/maps/GeoTiffLayerSidebySide';

const LeafletMapSideBySide = ({ data, leftSide, rightSide, ...rest }) => {
  const {
    config: { isRTL }
  } = useContext(AppContext);

  const { coordinates, mapData, legendData, label } = data;
  const [indexScale, setIndexScale] = useState([]);
  const [layerVisible, setLayerVisible] = useState(true);

  // useEffect(() => {
  //   setIndexScale(getColorScale(label));
  // }, [data]);

  const position = coordinates[0]?.[0];

  const fillColor = {
    color: 'white',
    fillColor: '#fff',
    opacity: 1,
    fillOpacity: 0
  };
  // const leftSideTiffUrl = mapData[leftSide].url;
  // const rightSideTiffUrl = mapData[rightSide].url;

  const leftSideTiffUrl = Object.entries(mapData).find(
    ([key]) => key === leftSide
  )?.[1].url;
  const rightSideTiffUrl = Object.entries(mapData).find(
    ([key]) => key === rightSide
  )?.[1].url;
  // const leftSideTiffUrl = mapData.find(item => item.key === leftSide).url;
  // const rightSideTiffUrl = mapData.find(item => item.key === rightSide).url;

  // const leftYear = mapData.find(item => item.key === leftSide).variant;
  // const rightYear = mapData.find(item => item.key === rightSide).variant;

  const leftYear = leftSide;
  const rightYear = rightSide;

  const fullTitle = label;

  if (isEmpty(leftSideTiffUrl) || isEmpty(rightSideTiffUrl)) {
    return null;
  }
  //nothing special

  return (
    <MapContainer
      zoom={isRTL ? 1.8 : 1.5}
      minZoom={isRTL ? 1.8 : 1.3}
      zoomSnap={0.5}
      center={position || [0, 0]}
      {...rest}
      radius={200}
    >
      <TileLayer
        attribution='Google Maps &copy; <a href="https://farmsio.com">Farmsio</a>'
        url="https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
      />
      {!isEmpty(data.coordinates) && (
        <Polygon pathOptions={fillColor} positions={data.coordinates} />
      )}
      {!isEmpty(leftSideTiffUrl && rightSideTiffUrl && legendData) && (
        <GeotiffLayerSideBySide
          leftUrl={leftSideTiffUrl}
          rightUrl={rightSideTiffUrl}
          title={label}
          coordinates={coordinates}
          indexScale={legendData ? legendData : indexScale}
          varients={[leftYear, rightYear]}
          layerVisible={layerVisible}
        />
      )}
      {(indexScale || legendData) && (
        <Legend
          indexScale={legendData || indexScale}
          title={fullTitle}
          setLayerVisible={setLayerVisible}
        />
      )}
    </MapContainer>
  );
};

export default LeafletMapSideBySide;
